<template>
  <customdialog
    v-model="dialog"
    :maxWidth="options.width"
    :title="title"
    :cardtextstyle="'height: 350px;'"
  >
    <v-flex>
      <span class="body-1">{{ $t('Pictures-uploaded-dimensions-viewed-problems') }} </span>
    </v-flex>
    <v-form
      ref="formaktarim"
      id="formaktarim"
      method="post"
      enctype="multipart/form-data"
      lazy-validation
    >
      <input
        class="custom-file-input"
        type="file"
        :label="$t('Select-File')"
        id="files"
        ref="files"
        @change="onFileChange"
        accept="image/jpeg"
      />
    </v-form>

    <br>
    <v-flex v-if="url != null">
    <img width="400px" height="200px"  alt="" :src="url" />
    </v-flex>

    <template slot="btn">
      <v-btn color="primary" flat @click.native="yes()">{{
        btnYesCaption
      }}</v-btn>
    </template>
  </customdialog>
</template>

<script>
import customdialog from "@/components/app/coper/comp/customdialog.vue";
import tool from "@/components/app/coper/tools";

export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,

      title: null,
      FileCode: null,
      btnYesCaption: this.$t('OK'),

      url: null,

      options: {
        color: "primary",
        width: 450,
      },
      files: [],
      fileBase64: "",
    };
  },
  components: {
    customdialog,
  },
  methods: {
    open(title, FileCode) {
      this.btnYesCaption = "Kaydet";
      this.title = title;
      this.FileCode = FileCode;
      this.fileBase64 = null;

      this.ResimYukle();
      this.dialog = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
      this.files = e.target.files;
    },

    yes() {
      if (this.files.length > 0) {
        let prm = {
          FileCode: this.FileCode,
        };

        //this.status.loading = true;
        tool.api_file_post2(this, "Coper/BinaryFileSave", this.files, prm).then(
          (response) => {
            this.resolve(true);
            this.dialog = false;
          },
          (response) => {
            this.status = tool.responseToStatus(response);
          }
        );
      }
    },
    cancel() {
      this.resolve(null);
      this.dialog = false;
    },

    base64toBlob(base64Data, contentType) {
      contentType = contentType || "";
      var sliceSize = 1024;
      var byteCharacters = atob(base64Data);
      var bytesLength = byteCharacters.length;
      var slicesCount = Math.ceil(bytesLength / sliceSize);
      var byteArrays = new Array(slicesCount);

      for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      return new Blob(byteArrays, { type: contentType });
    },
    ResimYukle() {
      var params = {
        FileCode: this.FileCode,
      };

      this.url =null;
      tool.http_post(this, "BinaryFileLoadBase64", params).then(
        (response) => {
          if (response.body.Status == true) {
            //this.mesaj = "Açıklamalar kaydedildi.";
            //this.snackbar = true;
            this.fileBase64 = response.body.data.imageBase64;
            this.url = URL.createObjectURL(
              this.base64toBlob(this.fileBase64, "image/jpeg")
            );
          } else {
            //this.mesaj = response.body.ErrorList[0];
            //this.snackbar = true;
          }
        },
        (response) => {
          //this.mesaj = "Hata oluştu, tekrar deneyiniz";
          //this.snackbar = true;
        }
      );
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  cursor: pointer !Important;
  font: 300 14px sans-serif;
  color:#9e9e9e;
}
input[type="file"]::-webkit-file-upload-button
{
  font: 300 14px  sans-serif;
  background: #009688;
  border: 0;
  padding: 12px 25px;
  cursor: pointer;
  color: #fff;
  text-transform: uppercase;
}
 
input[type="file"]::-ms-browse {
  font: 300 14px 'Roboto', sans-serif;
  background: #009688;
  border: 0;
  padding: 12px 25px;
  cursor: pointer;
  color: #fff;
  text-transform: uppercase;
}

</style>